import React, { useEffect } from "react";
import { Form } from "antd";
import dayjs from "dayjs";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import {
  getOptionsFromRefList,
} from "@/util/common_function";
import TextField from "@/common/elements/InputElements/TextField";
import CommonDatePicker from "@/common/elements/DatePicker";
import TimePicker from "@/common/elements/TimePicker";
import {
  getRefListNameByID,
} from "@/util/common_function";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import { SCHEMA_NAME } from "@/util/common_variable";
import SecureFormItem from "@/common/SecureFormItem";

const GroupMembersForm2 = ({ form, initialValues = {}, onFinish, disabled, startingPoint = "", staffGroupOptions = [] }) => {
  const staffGroup = staffGroupOptions;
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  useEffect(() => {
    if (initialValues?.staffGroupsID) {
      form.setFieldsValue({
        staffGroupsId: initialValues?.staffGroupsID,
        memberStaffId: initialValues?.memberStaffId,
        id: initialValues?.memberStaffId,
        dateAdded: initialValues.dateAdded
          ? dayjs(initialValues.dateAdded)
          : dayjs(),
        timeAdded: initialValues.timeAdded
          ? dayjs(initialValues.timeAdded, "HH:mm")
          : dayjs(),
        user: initialValues.user || getRefListNameByID("", userDetails?.staffId, true, false),
      });
    } else {
      if(form) form.resetFields();
    }
  }, [initialValues, form, staffGroup]);
  return (
    <>
      <StyledSectionHeading>
        <span>Staff Member Information</span>
      </StyledSectionHeading>
      <FieldSecurityProvider
        entity={SCHEMA_NAME.STAFF_GROUP_MEMBERS}
        startingPoint={startingPoint}
        bookingsFieldsEnabled={!disabled}
      >
        <Form form={form} onFinish={onFinish} disabled={disabled}>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={12}>  
              <FormItem name="staffGroupMembersID" style={{ display: 'none' }}>
                <TextField type="hidden" id="staffGroupMembersID" />
              </FormItem>
              <SecureFormItem
                fieldName="staffGroupsId"
                formItemProps={{ 
                  name: "staffGroupsId", 
                  label: "Staff Group To Add",
                  rules: [{ required: true, message: "Please select a staff group" }] 
                }}
              >
                <Select
                  showSearch
                  labelInValue
                  placeholder="Select group..."
                  options={staffGroup}
                  disabled={disabled}
                />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>

          {/* Administrative Info */}
          <StyledSectionHeading marginTop="20px">
            <span>Staff Group Member Administrative Information</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={2}>
              <SecureFormItem
                fieldName="id"
                formItemProps={{ name: "id", label: "Id" }}
              >
                <TextField disabled />
              </SecureFormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <SecureFormItem
                fieldName="dateAdded"
                formItemProps={{ name: "dateAdded", label: "Date Entered" }}
              >
                <CommonDatePicker placeholder="MM/DD/YYYY" format="MM/DD/YYYY" disabled />
              </SecureFormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <SecureFormItem
                fieldName="timeAdded"
                formItemProps={{ name: "timeAdded", label: "Time Entered" }}
              >
                <TimePicker placeholder="HH:mm" format="HH:mm" disabled />
              </SecureFormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <SecureFormItem
                fieldName="user"
                formItemProps={{ name: "user", label: "User" }}
              >
                <TextField disabled />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </FieldSecurityProvider>
    </>
  );
};

export default GroupMembersForm2;
